module.exports = __webpack_public_path__ + "img/dashboards-navbar-settings.50c2c1a0.svg";